const isSupportedNetwork = ({ walletConnector, network }) => {
    const evmNetworks = walletConnector.evmNetworks || [];
    const currentEvmNetwork = evmNetworks === null || evmNetworks === void 0 ? void 0 : evmNetworks.find((element) => element.chainId === network);
    return !(evmNetworks && evmNetworks.length && !currentEvmNetwork);
};

export { isSupportedNetwork };
